export default __webpack_public_path__ + "static/media/logo.1cbfc7b3.jpeg";